<template>
  <div class="content">
    <Nav
      class="left"
      :isCollapse="isCollapse"
      :navData="filterNavList"
      :active="active"
      @clickNav="clickNav"
      :style="{ width: leftWidth }"
    ></Nav>

    <div class="right" :style="{ width: rightWidth }">
      <Header :role="2" style="header" @collapse="collapse"></Header>
      <div class="content_right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header/index.vue";
import Nav from "@/components/navMenu/index.vue";
import { mapState,mapMutations } from "vuex";
export default {
  components: {
    Nav,
    Header,
  },

  async mounted() {
    /* 根据权限初始化导航 迁移到了store*/
    // this.navData = JSON.parse(JSON.stringify(this.navList));
    // this.filterFun(this.navData, this.roleList);
    // this.$store.commit("updataFilterNavList", this.navData);

    /* 初始化导航高亮 */
    // this.findFun(
    //   this.filterNavList,
    //   window.location.hash.substring(1, window.location.hash.length)
    // );
    // if (!this.active) {
    //   this.$router.push({ name: "Errow" });
    //   return;
    // }
  },

  data() {
    return {
      isCollapse: false, //是否折叠导航栏
      leftWidth: "220px",
      rightWidth: "calc(100% - 250px)",
      routerName: "",
      roleList: [], //权限
    };
  },
  computed: {
    ...mapState(["userInfo", "filterNavList","active"]),
  },
  watch: {},
  methods: {
    ...mapMutations(['updataActive']),
    clickNav(item) {
      // this.active = item.id;
      this.updataActive(item.id)
      this.routerName = item.routerName;
      this.$router.push({ name: item.routerName });
    },
    collapse(isCollapse) {
      this.isCollapse = isCollapse;
      if (isCollapse) {
        this.leftWidth = "65px";
        this.rightWidth = "calc(100% - 100px)";
      } else {
        this.leftWidth = "220px";
        this.rightWidth = "calc(100% - 260px)";
      }
    },
    /*  找到导航 id */
    // findFun(navData, path) {
    //   for (let index = 0; index < navData.length; index++) {
    //     if (navData[index]?.path === path) {
    //       this.active = navData[index]?.id;
    //     }
    //     if (
    //       navData[index]?.children &&
    //       navData[index]?.children.length > 0 &&
    //       navData[index]?.path !== path
    //     ) {
    //       this.findFun(navData[index].children, path);
    //     }
    //   }
    // },

    /* 筛选全量导航 */
    // filterFun(navData, roleList) {
    //   for (var index = navData.length - 1; index >= 0; index--) {
    //     if (
    //       navData[index]?.children &&
    //       navData[index]?.children.length > 0 &&
    //       roleList?.indexOf(navData[index].id) >= 0
    //     ) {
    //       this.filterFun(navData[index].children);
    //     }
    //     if (roleList?.indexOf(navData[index].id) < 0) {
    //       navData.splice(index, 1);
    //     }
    //   }
    // },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  margin: 0 auto;
  display: flex;
  min-width: 800px;
  .left {
  // outline: 1px solid red;
  overflow: hidden;
  }
  .right {
    // border: 5px solid red;
    height: 100vh;
    margin: 0 auto;
    // overflow-x: hidden;
    .header {
      width: 100%;
    }
    .content_right {
      margin: 20px auto;
      width: 100%;
      height: calc(100% - 100px);
      background: #fff;
      border-radius: 10px;
      overflow-y: scroll;
      padding: 20px;
    }
  }
}
</style>
